import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/shesha-functional-tests/adminportal/src/app/page.tsx");
